
const trySetLocalStorage = (key: string, value: string) => {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.localStorage.setItem(key, value)
  } catch (e) {
    console.error(e)
  }
}

const tryGetLocalStorage = (key: string): string | null => {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return window.localStorage.getItem(key) ?? null
  } catch (e) {
    console.error(e)
  }

  return null
}

const tryRemoveLocalStorage = (key: string) => {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    console.error(e)
  }
}

const trySetSessionStorage = (key: string, value: string) => {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.sessionStorage.setItem(key, value)
  } catch (e) {
    console.error(e)
  }
}

const tryGetSessionStorage = (key: string): string | null => {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return window.sessionStorage.getItem(key) ?? null
  } catch (e) {
    console.error(e)
  }

  return null
}

export {
  trySetLocalStorage,
  tryGetLocalStorage,
  tryRemoveLocalStorage,
  trySetSessionStorage,
  tryGetSessionStorage,
}